import { getConfig } from '../config';
import { location, redirect } from '../facade/window';

const config = getConfig();
export function returnAfterLogin() {
  redirect(getLogInUrl());
}

export function logout() {
  redirect(`${config.atlassianAccountUrl}/logout?continue=${encodeURIComponent(location().href)}`);
}

export function getLogInUrl(redirectUrl?: string) {
  const href = redirectUrl || location().href;
  return `${config.atlassianAccountUrl}/login?continue=${encodeURIComponent(href)}`;
}
